import { ChangeEvent, forwardRef, ReactNode } from 'react';
import { FormattedNumber } from 'react-intl';
import { Checkbox } from '@ebsco-ui/ebsco-ui';

import { FacetKey } from '@app/components';

import css from './FacetAttribute.module.scss';

interface FacetAttributeProps {
  label: ReactNode;
  value: string;
  isActive: boolean;
  facetKey: FacetKey;
  activeAttributesCount: number;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const FacetAttribute = forwardRef<HTMLInputElement, FacetAttributeProps>(
  (
    { isActive, facetKey, label, value, onChange, activeAttributesCount },
    ref
  ) => (
    <div
      className={css.facetAttribute}
      data-auto={`facet-${facetKey}-attribute`}
    >
      <Checkbox
        label={
          <span className={css.label}>
            <span className={css.labelTitle} data-auto="facet-attribute-title">
              {label}
            </span>
            <span className={css.labelValue} data-auto="facet-attribute-value">
              <FormattedNumber value={activeAttributesCount} />
            </span>
          </span>
        }
        value={value}
        checked={isActive}
        className={css.checkbox}
        ref={ref}
        onChange={onChange}
      />
    </div>
  )
);

FacetAttribute.displayName = 'FacetAttribute';
